export default __webpack_public_path__ + "static/media/court_information.898981cd.svg";